import { createRouter, createWebHistory } from 'vue-router';
import Wholesale from '../views/Wholesale.vue';
import VDP from '../components/vdp.vue';

const routes = [
    {
        path: '/',
        name: 'Wholesale',
        component: Wholesale,
        props: route => ({  dest_zip: route.query.dest_zip,
                            vehicle_types: route.query.vehicle_types,
                            makes: route.query.makes,
                            models: route.query.models,
                            colors: route.query.colors,
                            priceMin: route.query.priceMin,
                            priceMax: route.query.priceMax,
                            mileageMin: route.query.mileageMin,
                            mileageMax: route.query.mileageMax,
                            yearMin: route.query.yearMin,
                            yearMax: route.query.yearMax,
                            bobMin: route.query.bobMin,
                            bobMax: route.query.bobMax,
                            buyNow: route.query.buyNow,
                            optMoonroof: route.query.optMoonroof,
                            optNav: route.query.optNav,
                            optLeather: route.query.optLeather,
                            optTransmission: route.query.optTransmission,
                            optDrive: route.query.optDrive,
                            optBCamera: route.query.optBCamera,
                            optDiesel: route.query.optDiesel,
                            optCabType: route.query.optCabType,
                            optDoors: route.query.optDoors,
                            searchText: route.query.searchText,
                            low_mileage: route.query.low_mileage,
                            acvMin: route.query.acvMin,
                            acvMax: route.query.acvMax,
                            optThirdRow: route.query.optThirdRow,
                            optRearEntertainment: route.query.optRearEntertainment,
                            mMin: route.query.mMin
                        }),
        children: [
            { path: 'vdp/:vehicleInfo/:crashed', name: 'crashedvdp', component: VDP, props: true },
            { path: 'vdp/:vehicleInfo', name: 'vdp', component: VDP, props: true }
        ]
    },
    { path: '/login', name: 'Login', component: Wholesale, props: { login: true }},
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
